import { yupResolver } from "@hookform/resolvers/yup";
import { defaultFormValues as _defaultFormValues, schema } from "./constants";
import { UpdateQuickWinFormValues } from "./types";
import { FormProvider, useForm } from "react-hook-form";

export interface UpdateQuickWinFormProps {
  defaultFormValues?: Partial<UpdateQuickWinFormValues>;
  children?: React.ReactNode;
}
export const UpdateQuickWinForm = ({
  defaultFormValues,
  children,
}: UpdateQuickWinFormProps) => {
  const methods = useForm<UpdateQuickWinFormValues>({
    mode: "all",
    reValidateMode: "onChange",
    defaultValues: {
      ..._defaultFormValues,
      ...defaultFormValues,
    },
    resolver: yupResolver(schema),
  });

  return <FormProvider {...methods}>{children}</FormProvider>;
};
